import React from 'react';
import classnames from 'classnames';

import * as styles from './success.module.scss';

const Success = ({ data }) => {
  return (
    <div className={classnames(styles.success, 'scr-txt-center')}>
      <p className={classnames(styles.title, 'scr-lead')}>{data}</p>
    </div>
  );
};

export default Success;
